export default class PedidoSelo {

  constructor(pedidoSelo) {
    this.pedido = pedidoSelo.pedido;
    this.dataPedido = pedidoSelo.dataPedido;
    this.dataEntregaPedido = pedidoSelo.dataEntregaPedido;
    this.seloInicial = pedidoSelo.seloInicial;
    this.seloFinal = pedidoSelo.seloFinal;
    this.descricaoTipoSelo = pedidoSelo.descricaoTipoSelo;
  }
}



// WEBPACK FOOTER //
// ./src/domain/selo/pedido-selo.js